import { render } from "./AenderungsauftraegeSelfService.vue?vue&type=template&id=794c33ac&scoped=true"
import script from "./AenderungsauftraegeSelfService.vue?vue&type=script&lang=js"
export * from "./AenderungsauftraegeSelfService.vue?vue&type=script&lang=js"

import "./AenderungsauftraegeSelfService.vue?vue&type=style&index=0&id=794c33ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794c33ac"]])

export default __exports__